export const MailController = () => {

  $('.subscribe-submit').on('click', (e) => {
    e.preventDefault();

    if(validateSubscribeForm($(e.currentTarget)) != false) {
      sendForm($(e.currentTarget));
    }

  });

}

let validateSubscribeForm = (_this) => {
  var allow = true;

  _this.parent().removeClass('error');
  _this.parent().nextAll('.a-input__error').hide();

  if(!validateEmail($(_this.parent().find('.text-input')).val())) {
    _this.parent().addClass('error');
    _this.parent().nextAll('.a-input__error').show();
    allow = false;
  }

  return allow;
}

let sendForm = (_this) => {
  var data = {
    email: _this.parent().find('.text-input').val()
  }

  $.ajax({
    type: 'POST',
    data: data,
    url: 'api/mailchimp/index.php',
    success: (result) => {
      console.log(result);
      $(_this.parent().find('.text-input')).val("");
      _this.parent().nextAll('.a-input__error').hide();
      _this.parent().nextAll('.a-input__success').show();
    }
  });
}

let validateEmail = (dataEmail) => {
  var val = dataEmail;
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(val);
}



// WEBPACK FOOTER //
// ./src/js/controllers/MailController.js